import { takeLatest, put, call } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";

import Api from "../utils/api";

function* individualReportSaga({ payload }) {
  try {
    yield put(setIsLoading(true));
    const report = yield call(
      Api.get,
      `/report/forStaff/individual?${new URLSearchParams(payload).toString()}`
    );
    yield put(setIndividualReport(report.data.result));
    yield put(setIndividualRawReport(report.data.rawResult));
    const mean = report.data.mean;
    const median = report.data.median;
    const sd = report.data.sd;
    console.log("{ mean, median, sd }", { mean, median, sd });
    yield put(setIndividualStatisticData({ mean, median, sd }));
  } catch (err) {
    alert(err.response.data.message);
    console.log(err);
  }
  yield put(setIsLoading(false));
}

function* collectiveReportSaga({ payload }) {
  try {
    yield put(setIsLoading(true));
    const report = yield call(
      Api.get,
      `/report/forStaff/collective?${new URLSearchParams(payload).toString()}`
    );
    yield put(setCollectiveReport(report.data.result));
    yield put(setCollectiveRawReport(report.data.rawResult));
    const mean = report.data.mean;
    const median = report.data.median;
    const sd = report.data.sd;
    yield put(setCollectiveStatisticData({ mean, median, sd }));
  } catch (err) {
    alert(err.response.data.message);
    console.log(err);
  }
  yield put(setIsLoading(false));
}

function* getSchoolInfoSaga() {
  try {
    yield put(setIsLoading(true));
    const schoolInfo = yield call(Api.get, "/schools/info");
    yield put(setSchoolInfo(schoolInfo.data.school));
  } catch (err) {
    alert(err.response.data.message);
    console.log(err);
  }
  yield put(setIsLoading(false));
}

function* getUserIdOptionsSaga({ payload }) {
  try {
    yield put(setIsLoading(true));
    console.log(payload);
    const userIds = yield call(
      Api.get,
      `/report/forStaff/studentIds?${new URLSearchParams(payload).toString()}`
    );
    yield put(setUserIdsOptions(userIds.data.result));
  } catch (err) {
    alert(err.response.data.message);
    console.log(err);
  }
  yield put(setIsLoading(false));
}

function* getMatchListSaga({ payload }) {
  try {
    yield put(setIsLoading(true));
    console.log(payload);
    const matchList = yield call(Api.get, `/matches/getMatchList`);
    yield put(setMatchList(matchList.data.matchList));
  } catch (err) {
    alert(err.response.data.message);
    console.log(err);
  }
  yield put(setIsLoading(false));
}

export function* watchReportSaga() {
  yield takeLatest(onGetSchoolInfo.type, getSchoolInfoSaga);
  yield takeLatest(onGetUserIdsOptions.type, getUserIdOptionsSaga);
  yield takeLatest(onGetIndividualReport.type, individualReportSaga);
  yield takeLatest(onGetCollectiveReport.type, collectiveReportSaga);
  yield takeLatest(onGetMatchList.type, getMatchListSaga);
}

export const reportSlice = createSlice({
  name: "report",
  initialState: {
    isLoading: false,
    schoolInfo: {},
    studentIdOptions: [],
  },
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSchoolInfo: (state, action) => {
      state.schoolInfo = action.payload;
    },
    setUserIdsOptions: (state, action) => {
      state.studentIdOptions = action.payload;
    },
    setIndividualReport: (state, action) => {
      state.individualReport = action.payload;
    },
    setIndividualRawReport: (state, action) => {
      state.individualRawReport = action.payload;
    },
    setIndividualStatisticData: (state, action) => {
      state.individualStatistic = action.payload;
    },
    setCollectiveReport: (state, action) => {
      state.collectiveReport = action.payload;
    },
    setCollectiveRawReport: (state, action) => {
      state.collectiveRawReport = action.payload;
    },
    setCollectiveStatisticData: (state, action) => {
      state.collectiveStatistic = action.payload;
    },
    setMatchList: (state, action) => {
      state.matchList = action.payload;
    },
    onGetIndividualReport: () => {},
    onGetCollectiveReport: () => {},
    onGetSchoolInfo: () => {},
    onGetUserIdsOptions: () => {},
    onGetMatchList: () => {},
  },
});

export const {
  setIsLoading,
  setSchoolInfo,
  setIndividualReport,
  setIndividualRawReport,
  setIndividualStatisticData,
  setUserIdsOptions,
  setCollectiveReport,
  setCollectiveRawReport,
  setCollectiveStatisticData,
  setMatchList,
  onGetIndividualReport,
  onGetCollectiveReport,
  onGetSchoolInfo,
  onGetUserIdsOptions,
  onGetMatchList,
} = reportSlice.actions;

export default reportSlice.reducer;
